site.news = {
	init: function () {
		var $entries = $('.news.entries');
		if (!$entries) return false;

		$('a', '.loadMore').on('click', function (e) {
			e.preventDefault();
			$(this).addClass('loading');

			site.news.loadNews({
				url: $entries.data('url'),
				page: $entries.data('page'),
				total: $entries.data('total'),
			});
		});
		
		site.news.filter();
	},

	loadNews: function (options) {
		$.ajax({
			url: options.url + parseInt(options.page),
			dataType: 'json',
			success: function (r) {
				$('a', '.loadMore').removeClass('loading');
				var $entries = $('.news.entries');
				$entries.append(r);
				$entries.data('page', parseInt(options.page) + 1);

				if ($('.entry', $entries).length === options.total) {
					$('.loadMore').hide();
				}

				$('img.responsive:not(.loaded)').responsiveImg();

				site.news.updateQueryStringParam('page', options.page);
			},

			error: function (e) {
				console.log(e);
			}
		});
	},

	updateQueryStringParam: function(key, value) {
		if (typeof (history.pushState) !== 'undefined') {
			var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
				urlQueryString = document.location.search,
				newParam = key + '=' + value,
				params = '?' + newParam;

			// If the "search" string exists, then build params from it
			if (urlQueryString) {
				var keyRegex = new RegExp('([\?&])' + key + '[^&]*');

				// If param exists already, update it
				if (urlQueryString.match(keyRegex) !== null) {
					params = urlQueryString.replace(keyRegex, "$1" + newParam);
				} else { // Otherwise, add it to end of query string
					params = urlQueryString + '&' + newParam;
				}
			}
			window.history.replaceState({}, "", baseUrl + params);
		}
	},
	
	filter: function() {
		var $dateFrom = $('#dateFrom'),
			$dateTo = $('#dateTo');

		$dateFrom.bind('change', function () {
			var startArr = $dateFrom.val().split('.');
			var start = startArr[2] + startArr[1] + startArr[0];
			var finishArr = $dateTo.val().split('.');
			var finish = finishArr[2] + finishArr[1] + finishArr[0];

			if ($dateTo.val() === '' || finish < start) {
				$dateTo.val(site.news.getTodayDate());
			}
			$dateTo.datepicker("option", "minDate", new Date(startArr[2], startArr[1] - 1, startArr[0]));
		});

		$('#dateTo, #dateFrom').bind('keyup', function () {
			site.news.validateTime($(this));
		});

		$('select', '#newsFilter').on('change', function() {
			var $form = $(this).closest('form');
			$form.find('input[type=submit]').click();
		});

		var $submit = $('.elm_submit', '#newsFilter').clone()
			.removeClass('elm_submit').addClass('mobile_submit hidden-md hidden-lg');
		$('input', $submit).removeAttr('id');
		$('form', '#newsFilter').append($submit);

		site.maxHeight.init('#newsFilter form');

		var $body = $('body');
		if ($body.width() + 15 < 992) {
			$('#newsFilterToggle').on('click', function() {
				$body.toggleClass('filter-open');
			});
			$('#newsFilter').on('click', function(e) {
				e.stopPropagation();
			});
			$body.on('click', function() {
				if ($body.hasClass('filter-open')) {
					$body.removeClass('filter-open');
				}
			});
		}
	},
	
	validateTime: function($this) {
		var val = $this.val();

		$this.css('background', 'transparent');

		if (val.match(/^([0-1][0-9]:[0-5][0-9])|(2[0-3]:[0-5][0-9])$/) === null) {
			$this.css('background', '#fff0f0');
		}
	},

	getTodayDate: function() {
		var today = new Date();
		var dd = today.getDate();
		var mm = today.getMonth()+1; //January is 0!

		var yyyy = today.getFullYear();
		if(dd<10){
			dd='0'+dd;
		}
		if(mm<10){
			mm='0'+mm;
		}
		return dd+'.'+mm+'.'+yyyy;
	}
};
